import { getServerBaseUrl } from '@wix/bookings-catalog-calendar-viewer-utils';
import { BookingsViewerStorageManager } from '../BookingsViewerStorageManager/BookingsViewerStorageManager';
import { endpointConfigurations } from './configurations';
import { defaultDeserializer } from '../utils';
import { bookingsViewerCacheInteractionEnd, bookingsViewerCacheInteractionStart } from './fedops/fedops';
export const withBookingsViewerCache = flowAPI => {
  const {
    httpClient,
    environment: {
      isSSR
    },
    controllerConfig: {
      appParams,
      wixCodeApi
    }
  } = flowAPI;
  const host = getServerBaseUrl({
    appParams,
    wixCodeApi
  });
  const originalRequest = httpClient.request.bind(httpClient);
  const bookingsViewerStorageManager = new BookingsViewerStorageManager(flowAPI);
  const requestWithCache = async function () {
    let data;
    let method;
    let url;
    let deserializer = defaultDeserializer;
    let response;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    try {
      const [requestOrHttpRequestFactory] = args;
      if (typeof requestOrHttpRequestFactory === 'object') {
        ({
          data,
          method,
          url
        } = requestOrHttpRequestFactory);
      } else if (typeof requestOrHttpRequestFactory === 'function') {
        const options = requestOrHttpRequestFactory({
          host,
          isSSR
        });
        ({
          data,
          method,
          url,
          transformResponse: deserializer
        } = options);
      }
      if (!url || !method) {
        throw new Error('Invalid request parameters');
      }
      const matchedEndpoint = endpointConfigurations.find(endpoint => {
        var _url;
        return method === endpoint.method && ((_url = url) == null ? void 0 : _url.startsWith(endpoint.url));
      });
      if (matchedEndpoint) {
        const request = {
          method: method,
          url,
          body: data
        };
        bookingsViewerCacheInteractionStart({
          flowAPI,
          request
        });
        const {
          onResponse,
          requestToCacheKey
        } = matchedEndpoint;
        const defaultCacheKey = [method, url];
        const cacheKey = (requestToCacheKey == null ? void 0 : requestToCacheKey(request)) || defaultCacheKey;
        const cacheValue = bookingsViewerStorageManager.get(cacheKey);
        if (cacheValue) {
          const value = deserializer(cacheValue);
          bookingsViewerCacheInteractionEnd({
            flowAPI,
            cacheHit: true
          });
          return value;
        }
        response = await originalRequest(...args);
        onResponse == null || onResponse({
          bookingsViewerStorageManager,
          response
        });
        bookingsViewerStorageManager.set(cacheKey, response);
        bookingsViewerCacheInteractionEnd({
          flowAPI,
          cacheHit: false
        });
        return response;
      }
    } catch (error) {
      console.warn('Error in intercepted HTTP request:', error, {
        method,
        url,
        data
      });
      bookingsViewerCacheInteractionEnd({
        flowAPI,
        isError: true
      });
    }
    return response || originalRequest(...args);
  };
  flowAPI.httpClient.request = requestWithCache;
};
//# sourceMappingURL=withBookingsViewerCache.js.map